export default {"src":"/_next/static/media/sofa.21b30f6d.svg","height":300,"width":450,"blurWidth":0,"blurHeight":0};